<script lang="ts">
	import { _ } from 'svelte-i18n';
	import TooltipButton from '$lib/components/TextEditor/PostComposer/components/TooltipButton.svelte';
	import { isGeneratingPost } from '$lib/components/TextEditor/PostComposer/composerStore';

	export let isGenerateButtonDisabled: boolean;
	export let handleGeneratePost: () => Promise<void>;
	export let handleStopGenerating: () => void;

	const handlePromptGuideClick = () => {
		window.open(
			'https://insightcommunity.help.alida.com/redirect.html#7788078E99074C0F8CF898EF88CE300D',
			'_blank'
		);
	};

	const handleWebHelpClick = () => {
		window.open(
			'https://insightcommunity.help.alida.com/redirect.html#E500E0D19D894F56AB68B90B9D0558A4',
			'_blank'
		);
	};
</script>

<div class="action-buttons">
	<div class="info-buttons">
		<TooltipButton
			onClick={handlePromptGuideClick}
			imageSrc="/_static/AI/prompt_guide.svg"
			tooltipText={$_('hubs.copywriter.prompt_guide.tooltip')}
			imageWidth={24}
			imageHeight={24} />
		<TooltipButton
			onClick={handleWebHelpClick}
			imageSrc="/_static/AI/web_help.svg"
			tooltipText={$_('hubs.copywriter.web_help.tooltip')}
			imageWidth={24}
			imageHeight={24} />
	</div>
	{#if $isGeneratingPost}
		<TooltipButton
			onClick={handleStopGenerating}
			disabled={false}
			showTooltip={true}
			imageSrc="/_static/AI/stop_generating_button.svg"
			tooltipText={$_('hubs.copywriter.stop_generating_button.tooltip')}
			imageWidth={40}
			imageHeight={40} />
	{:else}
		<TooltipButton
			onClick={handleGeneratePost}
			disabled={isGenerateButtonDisabled}
			showTooltip={true}
			imageSrc={isGenerateButtonDisabled
				? '/_static/AI/generate_button_disabled.svg'
				: '/_static/AI/generate_button_enabled.svg'}
			tooltipText={$_('hubs.copywriter.generate_button.tooltip')}
			imageWidth={40}
			imageHeight={40} />
	{/if}
</div>

<style>
	.action-buttons {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.info-buttons {
		display: flex;
		padding-block-start: 0.5rem;
		padding-inline-start: 0.5rem;
		gap: 2.5rem;
	}
</style>
